import { useFormContext } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import { useBoolean } from "react-use";
import type { BroadcastContentAttributes } from "@/react/components/SettingsApp/Emails/hooks/useGetBroadcast";
import { broadcastPaths } from "@/react/helpers/urlHelpers/broadcastPaths";
import { ReplaceConfirmationModal } from "../ReplaceConfirmationModal";

export const useChangeTemplate = () => {
  const [isReplaceConfirmationModalOpen, toggleIsReplaceConfirmationModalOpen] =
    useBoolean(false);
  const { getValues } = useFormContext<BroadcastContentAttributes>();
  const history = useHistory();
  const { id: broadcastId } = useParams<{ id: string }>();

  const navigateToTemplateList = () => {
    history.push(
      broadcastPaths.listTemplates({ broadcastId: Number(broadcastId) }),
    );
  };

  const handleChangeTemplate = () => {
    const broadcastContent = getValues("email_content.body");
    if (broadcastContent) {
      return toggleIsReplaceConfirmationModalOpen(true);
    }

    navigateToTemplateList();
  };

  return {
    confirmReplaceElement: (
      <ReplaceConfirmationModal
        isOpen={isReplaceConfirmationModalOpen}
        onClose={toggleIsReplaceConfirmationModalOpen}
        onConfirm={() => {
          navigateToTemplateList();
          toggleIsReplaceConfirmationModalOpen();
        }}
      />
    ),
    onChangeTemplate: handleChangeTemplate,
  };
};
